import React, {useState} from "react";
import Grid from "@mui/material/Grid";
import MainPanelTabs from "./main-panel-tabs";
import Map from "../map/map";
import ResponsiveWebapp from "./responsive-webapp";
import {connect} from "react-redux";
import {isCrawler, isMobile} from '../../@opentripplanner/core-utils/src/ui'
import {useLocation, useNavigate} from "react-router-dom";
import AppBarHeader from "./appBarHeader";
import AppFooter from "./appFooter";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import {APP_BAR_HEIGHT, APP_FOOTER_HEIGHT} from "../../actions/ui";

function OptView(props) {
  const history = useNavigate();
  const location = useLocation();
  
  // More robust check for headless parameter
  const urlParams = new URLSearchParams(location.search);
  const isHeadless = urlParams.get('headless') === 'true';
  const isShowShell = !isHeadless;
  
  const appBarHeight = isShowShell ? APP_BAR_HEIGHT : 0;
  const appFooterHeight = isShowShell ? APP_FOOTER_HEIGHT : 4;

  /** desktop view **/
  const desktopView = (
    <>
      <Box sx={{display: 'flex'}}>
        {(isShowShell) && <AppBarHeader/>}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
          className='otp'
        >
          {isShowShell && <Toolbar sx={{height: appBarHeight}}/>}
          <Box
            sx={{height: `calc(100% - ${appBarHeight}px)`}}
          >
            <Box sx={{height: '100%'}}>
              <Grid
                container
                sx={{height: `calc(100% - ${appFooterHeight}px)`}}
              >
                <Grid item sm={6} md={4} className={isHeadless ? 'sidebar-headless' : 'sidebar'} zeroMinWidth>
                  <MainPanelTabs/>
                </Grid>
                {(isMobile() || isCrawler()) ? null : (<Grid item sm={6} md={8}>
                  <Map/>
                </Grid>)}
              </Grid>
              {/* Show footer unless explicitly hidden by headless mode or config */}
              {(!isHeadless && !props.config.hideFooter) && <AppFooter/>}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );

  /** mobile view **/
  // const mobileView = (
  //     <MobileMain map={(<Map/>)} title={(<div className='navbar-title'>OpenTripPlanner</div>)}/>
  // )


  /** the main webapp **/
  return (
    <ResponsiveWebapp
      desktopView={desktopView}
      mobileView={desktopView}
      history={history}
    />
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    config: state.otp.config,
  }
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(OptView)